import Api from '../api'

const api = new Api().init()

const updatePassword = (id, data) => {
  return api.put('/change-password-customer/' + id, data, {
    headers: {
      Authorization: 'Bearer ' + localStorage.getItem('token')
    }
  })
}

const sendEmail = (id, flag = 'customer') => {
  return api.post(`/account-info/${flag}/${id}`, null, {
    headers: {
      Authorization: 'Bearer ' + localStorage.getItem('token')
    }
  })
}

export default {
  updatePassword,
  sendEmail
}
